import React from 'react';
import './HealthBanner.scss';
import { RootState } from 'core/store';
import { useSelector } from 'react-redux';

const HealthBanner: React.FC = () => {
  const { apiHealth } = useSelector((state: RootState) => state.platform);

  // Don't show banner while loading or if request failed
  if (apiHealth === null) {
    return null;
  }

  // Only show banner if firebase is down (false or missing/undefined)
  if (!apiHealth) {
    return (
      <div id="health-banner">
        We’re currently experiencing an unexpected outage affecting our cloud
        services. We’re actively working to resolve the issue as quickly as
        possible.
      </div>
    );
  }

  return null;
};

export default HealthBanner;
